import React, { useState } from "react";
import axios from 'axios';
import { KRAKEN_URL } from '../../../../../constants'

//Estilos
import '../../../css/Configuracion.css'

//Componentes bootstrap
import { Modal, Form, Col, Container } from "react-bootstrap";
import { PencilSquare } from 'react-bootstrap-icons';
import { toast } from "react-toastify";

const EMAIL_REGEX = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

function ModalEditarUsuarioContacto(props) {
    const contacto = props.children;
    const [status, setStatus] = useState(false);
    const [nombreContacto, setNombreContacto] = useState(contacto.contacto);
    const [emailContacto, setEmailContacto] = useState(contacto.emailContacto);

    function handleContactoChange(e) {
        setNombreContacto(e.target.value);
    }

    function handleEmailContactoChange(e) {
        setEmailContacto(e.target.value);
    }

    function validateContacto() {
        if (nombreContacto.trim() === '') {
            toast.error('El campo "Nombre de contacto" es obligatorio', {
                position: "top-center",
                autoClose: 4500,
            });
            return;
        }

        if (emailContacto.trim() === '') {
            toast.error('El campo "Email de contacto" es obligatorio', {
                position: "top-center",
                autoClose: 4500,
            });
            return;
        }

        if (!EMAIL_REGEX.test(emailContacto.trim().toLowerCase())) {
            toast.error('Ingrese un correo electrónico válido (ejemplo: usuario@dominio.com)', {
                position: "top-center",
                autoClose: 4500,
            });
            return;
        }

        editarContacto();
    }

    function editarContacto() {
        setStatus(true);
        axios.post(KRAKEN_URL + 'empresa/usuario/contactos/update',
            {
                "contactoId": contacto.contactoId,
                "contacto": nombreContacto,
                "emailContacto": emailContacto
            }
        ).then((res) => {
            if (res.data.result.code === 200) {
                setStatus(false);
                toast.success(res.data.result.message,{
                    position:"top-center",
                    autoClose: 4500, 
                });
                props.onUpdate();//Actualiza el listado, llamando a la función padre para actualizarlo  
                props.onHide();//Cierra el modal, llamando a la función padre para cerrarlo 
            } else {
                setStatus(false);
                toast.warning(res.data.result.message,{
                    position:"top-center",
                    autoClose: 4500, 
                });
                toast.warning(res.data.result.suggestion,{
                    position:"top-center",
                    autoClose: 4500, 
                });
            }
        }).catch((error) => {
            setStatus(false);
            toast.error("Hubo un error, no se pudo agregar el contacto a este usuario.",{
                position:"top-center",
                autoClose: 4500, 
            });
        })
    }

    return (
        <section className="text-center">
            <Modal
                show={props.show}
                //onHide={props.onHide}
                size="md"
                centered
                id="modalEditarUsuarioContacto"
                scrollable={true}
            >
                <Modal.Header className="modal-header-empresa-usuario" closeButton onHide={props.onHide}>
                    <p><PencilSquare size={22} color="#5B4B51" />   Editar contacto</p>
                </Modal.Header>
                <Modal.Body>
                    <Container className="container-modals">
                        <Form.Row>
                            <Form.Group as={Col} lg={12}>
                                <fieldset>
                                    <legend className="legend-empresa-usuario">Datos del contacto</legend>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>Nombre de contacto</Form.Label>
                                            <Form.Control size="sm" id="username" type="text" required placeholder="Ingrese nombre de contacto" value={nombreContacto} onChange={handleContactoChange}></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col}>
                                            <Form.Label>Email de contacto</Form.Label>
                                            <Form.Control size="sm" id="email" type="text" required placeholder="Ingrese email de contacto" value={emailContacto} onChange={handleEmailContactoChange}></Form.Control>
                                        </Form.Group>
                                    </Form.Row>
                                </fieldset>
                            </Form.Group>
                        </Form.Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer className="justify-content-end">
                    <button
                        className="m-1 button-default-confirmar"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Editar"
                        disabled={status}
                        onClick={validateContacto}
                    >{status ? <span>Guardando...</span> : <span>Editar</span>}
                    </button>
                    <button
                        className="m-1 button-default-cancelar"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Cancelar"
                        onClick={props.onHide}
                    ><span>Cancelar</span>
                    </button>
                </Modal.Footer>
            </Modal>
        </section>
    )
}

export default ModalEditarUsuarioContacto;